import { z } from 'zod';

import { defaultPagingSchema } from '../../../../helpers/schemas/defaultPagingSchema';
import { advisorClientAccessFilterFormSchema } from '../components/AdvisorClientAccessFilter/helpers/getAdvisorClientAccessFilterFormSchema';

import { getAdvisorClientAccessFormSchema } from './getAdvisorClientAccessFormSchema';

const advisorClientAccessFormSchema = getAdvisorClientAccessFormSchema();

export const advisorClientAccessValidateSearchSchema =
	defaultPagingSchema.extend({
		...advisorClientAccessFormSchema.partial().shape,
		openedAdvisorClientUuid: z.uuid().optional().catch(undefined),
		filter: advisorClientAccessFilterFormSchema.optional().catch(undefined),
	});

export type AdvisorClientAccessValidateSearchSchemaType = z.infer<
	typeof advisorClientAccessValidateSearchSchema
>;
